import React from 'react';
import Header from '../components/Header';
import { database } from '../config';
import ReactTable from "react-table";
import "react-table/react-table.css";
const COLUMNS =
  [
    { Header: 'Id', accessor: 'id' },
    { Header: 'Name', accessor: 'name' },
    { Header: 'Hearts', accessor: 'hearts' },
    { Header: 'Money', accessor: 'money' },
    { Header: 'Points', accessor: 'points' },
  ];
const DATA1 =
  [
    {
      id: "1",
      name: "יוסי",
      hearts: "1",
      money: "5",
      points: "10"
    },
    {
      id: "2",
      name: "משה",
      hearts: "2",
      money: "5",
      points: "10"
    },
    {
      id: "3",
      name: "תומר",
      hearts: "3",
      money: "5",
      points: "10"
    },
  ];
class Users extends React.Component {
  constructor() {
    super();
    this.state = {

    }

  }

  componentDidMount() {

  }





  render() {
    return (
      <div>
        <Header pageTitle='Users' />
        <ReactTable
          data={DATA1}
          columns={COLUMNS}
          defaultPageSize={10}
          className="-striped -highlight"
        />

      </div>

    );
  }
}

export default Users;


// WEBPACK FOOTER //
// ./src/containers/Users.js